<template>
<div class="white">
  <v-layout align-center class="py-4"  :class="{'pl-4 pr-4' : $vuetify.breakpoint.xsOnly, 'pl-5 pr-4' : !$vuetify.breakpoint.xsOnly}">
    <v-flex grow >
      <h3>{{account.name}} </h3>
      <!-- {{account.official_name}} -->
      <p class="acc-descriptor py-0 my-0">{{account.subtype}} • {{account.balances.current | toCurrency(lang, safeCurrCode) }}</p>
    </v-flex>
    <v-flex shrink v-if="showTransactions" pr-5>
      <v-switch
      class="mt-0"
      hide-details
      v-model="showIncomeOnly"
      label="Show income only"
      ></v-switch>
    </v-flex>
    <v-flex shrink v-if="!showTransactionButton" pr-5>
      <p>Retrieving tranactions. <v-progress-circular
          indeterminate
          class="primary--text"
          :width="3"
          :size="20"></v-progress-circular><br>This can take a few minutes. </p>
    </v-flex>
    <v-flex  shrink>
      <v-btn class="mx-0" small depressed dark color="primary" @click="showTransactions = !showTransactions" v-if="showTransactionButton">{{showHideText}}</v-btn>
    </v-flex>
  </v-layout>
  <div :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
  <bank-transactions v-if="showTransactions" :transactions="filteredTransactions"></bank-transactions>
  </div>
  <v-divider></v-divider>
</div>
</template>

<script>
import BankTransactions from '@/components/Shared/BankTransactions'

export default {
  components: {
    BankTransactions
  },
  props: {
    account: {
      type: Object
    },
    transactions: {
      type: Array
    }
  },
  data () {
    return {
      showIncomeOnly: false,
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol,
      showTransactions: false
    }
  },
  computed: {
    showTransactionButton () {
      return this.transactions.length
    },
    filteredTransactions () {
      if (this.showIncomeOnly) {
        // return only transactions that are negative (ie. money flowing in)
        const filteredTransactions = this.transactions.filter(t => Math.sign(t.amount) === -1)
        return filteredTransactions
      } else {
        // return all transactions
        return this.transactions
      }
    },
    showHideText () {
      return !this.showTransactions ? 'Show' : 'Hide'
    },
    safeCurrCode () {
      return this.account.balances.iso_currency_code || this.currCode
    }
  }
}
</script>

<style scoped>
.acc-descriptor{
  text-transform: capitalize;
}
</style>
